<template>
  <svg
    id="eTLUys1zd0I1"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    viewBox="0 0 1600 900"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="eTLUys1zd0I2_ts" transform="translate(360,60) scale(0.2,0.2)">
      <ellipse
        id="eTLUys1zd0I2"
        fill="#fff"
        fill-opacity="0.35"
        opacity="0"
        rx="120"
        ry="120"
        stroke-width="0"
        transform="translate(0,0)"
      />
    </g>
    <g id="eTLUys1zd0I3_ts" transform="translate(1660,320) scale(0.2,0.2)">
      <ellipse
        id="eTLUys1zd0I3"
        fill="#fff"
        fill-opacity="0.35"
        opacity="0"
        rx="120"
        ry="120"
        stroke-width="0"
        transform="translate(0,0)"
      />
    </g>
    <g id="eTLUys1zd0I4_ts" transform="translate(1400,580) scale(0.2,0.2)">
      <ellipse
        id="eTLUys1zd0I4"
        fill="#84d0f5"
        fill-opacity="0.65"
        opacity="0"
        rx="120"
        ry="120"
        stroke-width="0"
        transform="translate(0,0)"
      />
    </g>
    <g id="eTLUys1zd0I5_ts" transform="translate(1660,580) scale(0.2,0.2)">
      <ellipse
        id="eTLUys1zd0I5"
        fill="#fff"
        fill-opacity="0.35"
        opacity="0"
        rx="120"
        ry="120"
        stroke-width="0"
        transform="translate(0,0)"
      />
    </g>
    <g id="eTLUys1zd0I6_ts" transform="translate(1140,840) scale(0.2,0.2)">
      <ellipse
        id="eTLUys1zd0I6"
        fill="#fff"
        fill-opacity="0.35"
        opacity="0"
        rx="120"
        ry="120"
        stroke-width="0"
        transform="translate(0,0)"
      />
    </g>
  </svg>
</template>
<style scoped>
#eTLUys1zd0I2_ts {
  animation: eTLUys1zd0I2_ts__ts 2000ms linear 1 normal forwards;
}
@keyframes eTLUys1zd0I2_ts__ts {
  0% {
    transform: translate(360px, 60px) scale(0.2, 0.2);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  50% {
    transform: translate(360px, 60px) scale(1, 1);
  }
  100% {
    transform: translate(360px, 60px) scale(1, 1);
  }
}
#eTLUys1zd0I2 {
  animation: eTLUys1zd0I2_c_o 2000ms linear 1 normal forwards;
}
@keyframes eTLUys1zd0I2_c_o {
  0% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
#eTLUys1zd0I3_ts {
  animation: eTLUys1zd0I3_ts__ts 2000ms linear 1 normal forwards;
}
@keyframes eTLUys1zd0I3_ts__ts {
  0% {
    transform: translate(1660px, 320px) scale(0.2, 0.2);
  }
  10% {
    transform: translate(1660px, 320px) scale(0.2, 0.2);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  60% {
    transform: translate(1660px, 320px) scale(1, 1);
  }
  100% {
    transform: translate(1660px, 320px) scale(1, 1);
  }
}
#eTLUys1zd0I3 {
  animation: eTLUys1zd0I3_c_o 2000ms linear 1 normal forwards;
}
@keyframes eTLUys1zd0I3_c_o {
  0% {
    opacity: 0;
  }
  10% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
#eTLUys1zd0I4_ts {
  animation: eTLUys1zd0I4_ts__ts 2000ms linear 1 normal forwards;
}
@keyframes eTLUys1zd0I4_ts__ts {
  0% {
    transform: translate(1400px, 580px) scale(0.2, 0.2);
  }
  20% {
    transform: translate(1400px, 580px) scale(0.2, 0.2);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  70% {
    transform: translate(1400px, 580px) scale(1, 1);
  }
  100% {
    transform: translate(1400px, 580px) scale(1, 1);
  }
}
#eTLUys1zd0I4 {
  animation: eTLUys1zd0I4_c_o 2000ms linear 1 normal forwards;
}
@keyframes eTLUys1zd0I4_c_o {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
#eTLUys1zd0I5_ts {
  animation: eTLUys1zd0I5_ts__ts 2000ms linear 1 normal forwards;
}
@keyframes eTLUys1zd0I5_ts__ts {
  0% {
    transform: translate(1660px, 580px) scale(0.2, 0.2);
  }
  30% {
    transform: translate(1660px, 580px) scale(0.2, 0.2);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  80% {
    transform: translate(1660px, 580px) scale(1, 1);
  }
  100% {
    transform: translate(1660px, 580px) scale(1, 1);
  }
}
#eTLUys1zd0I5 {
  animation: eTLUys1zd0I5_c_o 2000ms linear 1 normal forwards;
}
@keyframes eTLUys1zd0I5_c_o {
  0% {
    opacity: 0;
  }
  30% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
#eTLUys1zd0I6_ts {
  animation: eTLUys1zd0I6_ts__ts 2000ms linear 1 normal forwards;
}
@keyframes eTLUys1zd0I6_ts__ts {
  0% {
    transform: translate(1140px, 840px) scale(0.2, 0.2);
  }
  40% {
    transform: translate(1140px, 840px) scale(0.2, 0.2);
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  90% {
    transform: translate(1140px, 840px) scale(1, 1);
  }
  100% {
    transform: translate(1140px, 840px) scale(1, 1);
  }
}
#eTLUys1zd0I6 {
  animation: eTLUys1zd0I6_c_o 2000ms linear 1 normal forwards;
}
@keyframes eTLUys1zd0I6_c_o {
  0% {
    opacity: 0;
  }
  40% {
    opacity: 0;
    animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  }
  90% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
</style>
